import CoreApi from '@/api/CoreApi';
import type { UserGroupRole, NewUserGroupRole } from '@/models/GroupRole';
import type { GroupRole } from '@/models/Roles';

export async function getRoles(): Promise<GroupRole[]> {
  try {
    const response = await CoreApi.axiosClient.get(`/groups/roles`);
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(`Failed to load roles: ${error.message}`);
  }
}

export async function getGroupRoles(
  groupUuid: string,
): Promise<UserGroupRole[]> {
  try {
    const response = await CoreApi.axiosClient.get(
      `/groups/roles/${groupUuid}`,
    );
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(`Failed to load group roles: ${error.message}`);
  }
}

export async function createGroupRole(
  newGroupRole: NewUserGroupRole,
  groupUuid: string,
): Promise<void> {
  try {
    const response = await CoreApi.axiosClient.post(
      `/groups/roles/${groupUuid}`,
      newGroupRole,
    );
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(`Failed to create group role: ${error.message}`);
  }
}

export async function patchGroupRole(
  updateGroupRole: NewUserGroupRole,
  groupUuid: string,
): Promise<void> {
  try {
    const response = await CoreApi.axiosClient.patch(
      `/groups/roles/${groupUuid}`,
      updateGroupRole,
    );
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(`Failed to patch group role: ${error.message}`);
  }
}

export async function deleteGroupRole(
  email: string,
  groupUuid: string,
): Promise<void> {
  try {
    const response = await CoreApi.axiosClient.delete(
      `/groups/roles/${groupUuid}?email=${email}`,
    );
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(`Failed to delete group role: ${error.message}`);
  }
}
